/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';
import * as _ from 'lodash';

import AppHeader from '../../applicationFrame/AppHeader';
import { selectors as listSelectors } from '../../redux/ducks/lists/lists';

function mapStateToProps(state, routerProps) {
  const { colorTheme } = routerProps;
  return {
    colorTheme: _.assign({}, listSelectors.getCurrentColorTheme(state), colorTheme),
  };
}

export default connect(mapStateToProps)(AppHeader);
